import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { ReactUINodes } from 'common/enums/common.js';
import { KnowEdmTableData } from '../table-enums.js';
import { KnowEdmTableValue } from '../../interfaces.js';

const surveyProgramAssociatedDataMap = new Map<KnowEdmTableData, KnowEdmTableValue<KnowEdmTableData>>();

surveyProgramAssociatedDataMap.set(KnowEdmTableData.DepthMD, {
  key: KnowEdmTableData.DepthMD,
  label: RecognisedHeaderLabels.ProjectTD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyProgramAssociatedDataMap.set(KnowEdmTableData.DrillfloorHeight, {
  key: KnowEdmTableData.DrillfloorHeight,
  label: RecognisedHeaderLabels.DrillfloorHeight,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyProgramAssociatedDataMap.set(KnowEdmTableData.GroundElevation, {
  key: KnowEdmTableData.GroundElevation,
  label: RecognisedHeaderLabels.GroundElevation,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyProgramAssociatedDataMap.set(KnowEdmTableData.HoleSize, {
  key: KnowEdmTableData.HoleSize,
  label: RecognisedHeaderLabels.HoleSize,
  unit: '',
  quantity: '',
  type: ReactUINodes.Select,
});

export { surveyProgramAssociatedDataMap };
